const currentHost = window.location.hostname;

// Regex to match common file extensions (customize as needed)
const fileExtensionRegex = /\.[0-9a-z]+$/i;

document.querySelectorAll("a[href]").forEach((link) => {
	try {
		const url = new URL(link.href, window.location.origin);

		if (url.hostname !== currentHost) {
			if (link.target !== "_blank") {
				link.setAttribute("target", "_blank");
			}

			const ariaLabel = link.getAttribute("aria-label");
			if (ariaLabel) {
				// If aria-label exists, append the opens in new window text
				const ariaLabelText =
					ariaLabel + " (" + bds_theme.strings.opens_new_window + ")";
				link.setAttribute("aria-label", ariaLabelText);
			} else {
				// If aria-label doesn't exist, use the link text + opens in new window
				const linkText = link.textContent.trim();
				const ariaLabelText = linkText
					? linkText + " (" + bds_theme.strings.opens_new_window + ")"
					: bds_theme.strings.opens_new_window;
				link.setAttribute("aria-label", ariaLabelText);
			}
		}

		// Add title for file links
		const pathname = url.pathname;
		const match = pathname.match(fileExtensionRegex);

		if (match) {
			const filename = pathname.split("/").pop();
			link.setAttribute("title", `Download: ${filename}`);
		}
	} catch (e) {
		// Ignore invalid URLs.
	}
});
